import React from "react";
import { AkademiBanner } from "components/akademi-gurujuara/akademi-banner/akademi-banner";
import { AkademiAbout } from "components/akademi-gurujuara/akademi-about/akademi-about";
import { AkademiMain } from "styles/pages/akademi/akademi.styles";
import { AkademiBecomeTeacher } from "components/akademi-gurujuara/akademi-become-teacher/akademi-become-teacher";
import { InfoCard } from "components/info-card/info-card";
import { akademiInfoCard } from "data/akademi-infocard";
import { AkademiSteps } from "components/akademi-gurujuara/akademi-steps/akademi-steps";
import { AkademiStudentType } from "components/akademi-gurujuara/akademi-student-type/akademi-student-type";
import { colors } from "styles/constants/colors";

const Akademi: React.FC = () => {
  return (
    <AkademiMain>
      <AkademiBanner />
      <AkademiAbout />
      <AkademiBecomeTeacher />
      {akademiInfoCard.map((card, id) => (
        <InfoCard key={id} {...card} backgroundColor={colors.blue[50]} />
      ))}
      <AkademiStudentType />
      <AkademiSteps />
    </AkademiMain>
  );
};

export default Akademi;
